import React from 'react';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import { NavLink, useNavigate } from 'react-router-dom';
import { withStyles, createStyles } from '@material-ui/core/styles';
import { reactGaEvent } from 'examsbook-react-sdk/actions/Common';
import { convertToDate } from "examsbook-react-sdk/common";
import { useTimeRemainingQuiz } from "examsbook-react-sdk/custom-hooks";
import CrownIcon from "../../../assets/images/icons-crown.svg";
import { useQuizButtonStatus, useIsPremiumUser } from "examsbook-react-sdk/custom-hooks";

// noinspection JSAnnotator
const StyledTableCell = withStyles((theme) =>
    createStyles({
        head: {
            backgroundColor: theme.palette.common.black,
            color: theme.palette.common.white,
        },
    }),
)(TableCell);

// noinspection JSAnnotator
const StyledTableRow = withStyles((theme) =>
    createStyles({
        root: {
            '&:nth-of-type(odd)': {
                backgroundColor: theme.palette.background.default,
            },
        },
    }),
)(TableRow);

/**
 * Release plan for desktop.
 * @param props
 * @returns {*}
 * @constructor
 */
function ReleaseTableBody(props) {
    const { t, quiz } = props;
    const timeRemaining = useTimeRemainingQuiz(quiz);
    const disabled = true;
    const navigate = useNavigate();
    const { action, label } = useQuizButtonStatus(quiz);
    const isPremium = useIsPremiumUser();

    function onResultViewClick() {
        reactGaEvent("Test", "Result");
    }

    function gotoPage(location) {
        navigate('/my-app/' + location);
        reactGaEvent("Live Test", "Start Quiz");
    }

    function handleClickAction() {
        if (action === 'PAYMENT') {
            //open payment popup and make payment.
            navigate("/my-app/payments");
        }
    }

    const status = quiz.status;
    const currentDate = new Date().getTime();
    return (
        <StyledTableRow>
            <StyledTableCell>{
                quiz.pricing === "PAID" && <img src={CrownIcon} alt="crown icon" className="crownIcon"/>
            } {quiz.name}</StyledTableCell>
            <StyledTableCell align="center">{quiz.total ? quiz.total : quiz.totalQuestions}</StyledTableCell>
            <StyledTableCell align="center">{quiz.duration}</StyledTableCell>
            <StyledTableCell align="center">
                    <span
                        className={quiz.startDate && quiz.endDate ? quiz.startDate > currentDate ? '' : quiz.endDate > currentDate ?
                            'green-color' : 'red-color' : 'green-color'}>
                    {quiz.startDate && quiz.endDate ? quiz.startDate > currentDate ? convertToDate(quiz.startDate) : quiz.endDate && quiz.endDate > currentDate ?
                        t('Available') : t('Expired') : t('Available')}
                    </span>
            </StyledTableCell>
            <StyledTableCell align="center">
                    <span className={quiz.endDate ? quiz.endDate > currentDate ? '' : 'red-color' : 'green-color'}>
                        {quiz.endDate ? quiz.endDate > currentDate ? convertToDate(quiz.endDate) : t('Expired') : t('Available')}
                        </span>
            </StyledTableCell>
            <StyledTableCell align="center">
                {quiz.startDate <= new Date().getTime() || !quiz.startDate ?
                    <span>
                             {quiz.attempted && (quiz.endDate && quiz.endDate > new Date().getTime()) ?
                                 quiz.progressed ?
                                     //condition to check progressed quiz is not submitted
                                     <div onClick={() => gotoPage('quiz/' + quiz.mode + '/' + quiz.slug)}>
                                         <button>{t('RESUME_QUIZ')}
                                         </button>
                                     </div> :
                                     //condition to submitted quiz result date
                                     !quiz.resultDate || (quiz.resultDate && quiz.resultDate <= new Date().getTime()) ?
                                         <NavLink to={'/my-app/tests/result/' + quiz._id}>
                                             <button onClick={onResultViewClick}>
                                                 {t('view_result')}
                                             </button>
                                         </NavLink> :
                                         <button disabled={disabled}>
                                             {t('Result_pending')}{timeRemaining}
                                         </button>
                                 : // to check quiz is expired
                                 quiz.endDate && quiz.endDate < new Date().getTime() ?
                                     <button disabled={disabled}>
                                         {t('Expired')}
                                     </button> :
                                     // checlk if quiz is paid
                                     quiz.pricing === "PAID" && !isPremium ?
                                         <button onClick={handleClickAction}>
                                             {label}
                                         </button> :
                                         <div onClick={() => gotoPage('quiz/' + quiz.mode + '/' + quiz.slug)}>
                                             {!quiz.progressed ? !status ? <button disabled={disabled}>
                                                         {t('start_quiz')}
                                                     </button> :
                                                     <button
                                                         onClick={() => gotoPage('quiz/' + quiz.mode + '/' + quiz.slug)}>
                                                         {t('start_quiz')}
                                                     </button>
                                                 : <button>{t('RESUME_QUIZ')}
                                                 </button>
                                             }
                                         </div>
                             }
                        </span> : timeRemaining ?
                        <button disabled={disabled}>{t('live_in')}{timeRemaining}</button> : ''
                }
            </StyledTableCell>
        </StyledTableRow>
    );
}

export default ReleaseTableBody;
